import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CxIconComponent } from '../../shared/icon/cx-icon.component';

@Component({
  selector: 'app-upcoming-virtual-townhall',
  standalone: true,
  imports: [CommonModule, RouterModule, CxIconComponent],
  templateUrl: './upcoming-virtual-townhall.component.html',
  styleUrls: ['./upcoming-virtual-townhall.component.scss'],
})
export class UpcomingVirtualTownhallComponent implements OnInit {
  virtualEventReturnUrl = environment.virtualEventUrl;

  // Timer properties
  countdownDate = new Date('2026-06-08T19:15:00-04:00').getTime();
  days: number = 0;
  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;

  ngOnInit(): void {
    this.startTimer();
  }

  startTimer() {
    setInterval(() => {
      const now = new Date().getTime();
      const distance = this.countdownDate - now;

      if (distance < 0) {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    }, 1000);
  }
}
